<div id="coordinator-list">
    <div class="coordinator-list-filter">
        <!-- <div class="coordinator-search-wrapper">
            <div class="coordinator-search-block">
                <input type="text" (keyup)="onSearchChange($event.target.value)" class="coordinator-search-input" autocomplete="off">
                <button type="button"></button>
            </div>
        </div> -->
    </div>
    <div class="coordinator-list">
        <ul class="coordinator-bottom-padding">
            <ng-container>
                <li (click)="onNodesClick(item)"  [ngClass]="{'selected': selectedItem === item}" class="coordinator-each-loop" *ngFor="let item of coordinatorsDataSource">
                    <a>{{item.nombre}}</a>
                </li>
               
            </ng-container>
        </ul>
    </div>
    <div class="add-new-coordinator">
        <button *ngIf="doctorAddPremit" type="button" (click)="AddnewCoordinator(null)"><span>+</span></button>
    </div>
</div>
